module.exports = __webpack_public_path__ + "img/ai_generate_small.ac04058f.svg";